export default __webpack_public_path__ + "static/media/student-video-off.9fd4c04e.svg";